const currentYear = new Date().getFullYear();
const DefaultClosingDateAzofert = new Date(currentYear, 7, 1);
const DefaultOpeningDateAzofert = new Date(currentYear + 1, 1, 15);

export const ConstantsFertilizer = {
    DefaultClosingDateAzofert: DefaultClosingDateAzofert,
    DefaultOpeningDateAzofert: DefaultOpeningDateAzofert
};

export default ConstantsFertilizer;